/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_PhoneInputs */

const vi_shop_account_col_phone = /** @type {(inputs: Shop_Account_Col_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SĐT`)
};

/**

* @param {Shop_Account_Col_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_phone = /** @type {((inputs?: Shop_Account_Col_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_phone(inputs)
});